import React from 'react'
import './price.css'
import Table from './Table.js'


function Price() {

  return (
    <>
    <div className='price-container'>
      <Table></Table>
    </div>
      
    </>
  

  )
  }
export default Price